import React, { useEffect, useState } from "react";
import { getCompleteData, getItems, getYears } from "../../../actions/HomeAction";
import Axios from "../../../axios/axios";

function BuildingAdvancedSearch({ onResults, currentParts, categoryId }) {
  // Initial filter structure
  const initialFilters = {
    year: "",
    regionId: "",
    brandId: "",
    modelId: "",
    features: "",
    application: "",
    subcategoryId: "", 
    categoryId: categoryId || "",
  };

  const [filters, setFilters] = useState(initialFilters);
  const [regions, setRegions] = useState([]);
  const [years, setYears] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [categories, setCategories] = useState([]);
const [subcategories, setSubcategories] = useState([]);
  // Fetch dropdown data
useEffect(() => {
  getItems(setRegions);
  setYears(getYears());
  getCompleteData(setBrands, () => {}, setModels);

  // FETCH CATEGORIES ALSO (IMPORTANT)
  Axios.get("/categories").then(res => {
    setCategories(res.data);
  });
}, []);

 useEffect(() => {
  if (!categoryId || categories.length === 0) {
    setSubcategories([]);
    return;
  }

  const selectedCategory = categories.find(c => c._id === categoryId);

  if (selectedCategory?.subcategories?.length > 0) {
    setSubcategories(selectedCategory.subcategories);
  } else {
    setSubcategories([]);
  }
}, [categoryId, categories]);


  // Filter parts whenever filters or currentParts change
useEffect(() => {
  if (onResults) onResults(filters);
}, [filters.year, filters.regionId, filters.brandId, filters.modelId, filters.features, filters.application, filters.subcategoryId ]);


  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

 

  // Clear filters
  const clearFilters = () => {
    setFilters(initialFilters);
    if (onResults && currentParts) {
      onResults(currentParts);
    }
  };

  return (
    <div className="container py-4">
      <h4 className="mb-3">Building Materials Advanced Search</h4>

      {/* Clear Filters Button */}
      <button
        type="button"
        className="btn btn-sm btn-secondary mb-3"
        onClick={clearFilters}
      >
        Clear Filters
      </button>

      {subcategories.length > 0 && (
  <div className="advanced-filter-wrapper mb-2">
    <select
      name="subcategoryId"
      value={filters.subcategoryId}
      className="form-control"
      onChange={handleChange}
    >
      <option value="">Select Subcategory</option>
      {subcategories.map((sc) => (
        <option key={sc._id} value={sc._id}>
          {sc.name}
        </option>
      ))}
    </select>
  </div>
)}


      {/* Year */}
      <div className="advanced-filter-wrapper mb-2">
        <select
          name="year"
          value={filters.year}
          className="form-control"
          onChange={handleChange}
        >
          <option value="">Select Year</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      {/* Region */}
      <div className="advanced-filter-wrapper mb-2">
        <select
          name="regionId"
          value={filters.regionId}
          className="form-control"
          onChange={handleChange}
        >
          <option value="">Select Region</option>
          {regions.map((r) => (
            <option key={r._id} value={r._id}>
              {r.name}
            </option>
          ))}
        </select>
      </div>

      {/* Brand */}
      <div className="advanced-filter-wrapper mb-2">
        <select
          name="brandId"
          value={filters.brandId}
          className="form-control"
          onChange={handleChange}
        >
          <option value="">Select Brand</option>
          {brands.map((b) => (
            <option key={b._id} value={b._id}>
              {b.name}
            </option>
          ))}
        </select>
      </div>

      {/* Model */}
      <div className="advanced-filter-wrapper mb-2">
        <select
          name="modelId"
          value={filters.modelId}
          className="form-control"
          onChange={handleChange}
        >
          <option value="">Select Model</option>
          {models.map((m) => (
            <option key={m._id} value={m._id}>
              {m.name}
            </option>
          ))}
        </select>
      </div>

      {/* Features */}
      <div className="advanced-filter-wrapper mb-2">
        <input
          type="text"
          name="features"
          value={filters.features}
          placeholder="Features"
          className="form-control"
          onChange={handleChange}
        />
      </div>

      {/* Application */}
      <div className="advanced-filter-wrapper mb-2">
        <input
          type="text"
          name="application"
          value={filters.application}
          placeholder="Application"
          className="form-control"
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

export default BuildingAdvancedSearch;
